import { render, staticRenderFns } from "./mcInboundList.vue?vue&type=template&id=051486b0"
import script from "./mcInboundList.vue?vue&type=script&lang=js"
export * from "./mcInboundList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports